<a mat-raised-button *ngIf="signedIn" (click)="signOut()">Sign Out</a>
<a mat-raised-button *ngIf="!signedIn" (click)="signIn()">Sign In</a>
